import React, { useState } from "react";
import { useSelector } from "react-redux";
import TimeseriesPlotly from "pages/Dashboard/Timeseries/TimeseriesPlotly";

const SmartInsightTimeSeriesData = ({ title, color, tagId, endTime }) => {
  const [error, setError] = useState(null);
  const { tagsAsObj } = useSelector(state => state.tags);
  const getTagUnit = () => (tagsAsObj && tagsAsObj[tagId]["Units"]) || "";
  const tagData = { TagId: tagId, TagName: title, Units: getTagUnit() };

  return (
    <>
      <div className="font16 padding-left-10" style={{ color: `${color}` }}>
        {title}
      </div>
      <TimeseriesPlotly tagData={tagData} isSmartInsight={true} endTime={endTime} setError={setError} />
    </>
  );
};

export default SmartInsightTimeSeriesData;
